module.exports = __webpack_public_path__ + "media/images/fan_club/reward-d5ff78684c8f1a9beb92e4acde62cd47.jpg";